// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__yEgVW {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 12px;
  min-height: 100vh;
  min-height: var(--app-height);
}
.Modal_modal_order__N0KTm {
  padding-left: 0;
  padding-right: 0;
}
.Modal_modal_order__N0KTm .Modal_modal__wp__9E-J9 {
  padding-top: 99px;
  padding-bottom: 0px;
}
.Modal_modal_order__N0KTm .Modal_modal__body__PtdMz {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  height: auto;
}
.Modal_modal_order__N0KTm .Modal_modal__content__t8Fmf {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.Modal_modal_order__N0KTm .Modal_modal__wrapper__i6X9l {
  align-items: flex-end;
}
.Modal_modal__wrapper__i6X9l {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 100%;
  width: 100%;
}
.Modal_modal__wp__9E-J9 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-height: 100vh;
  min-height: var(--app-height);
  overflow-y: auto;
  overflow-x: hidden;
  background: rgba(0, 0, 0, 0.4);
}
.Modal_modal__body__PtdMz {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  padding: 12px;
  width: 100%;
}
.Modal_modal__content__t8Fmf {
  position: relative;
  z-index: 2;
  width: 100%;
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  max-width: 756px;
  transition: 0.3s;
  opacity: 0;
}
.Modal_modal__content_opened__CQEhb {
  opacity: 1;
}
.Modal_modal__logo__eOnGs {
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
}
.Modal_modal__logo__eOnGs svg, .Modal_modal__logo__eOnGs img {
  max-width: 200px;
  height: auto;
}
.Modal_modal__logoTxt__m3SkR {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--gray-500);
  display: flex;
}
.Modal_modal__yEgVW div.Modal_modal__lang__ZZiAz {
  position: absolute;
  top: 42px;
  right: 12px;
}
@media (min-width: 640px) {
  .Modal_modal__yEgVW div.Modal_modal__lang__ZZiAz {
    right: 30px;
  }
}
@media (min-width: 768px) {
  .Modal_modal__body__PtdMz {
    align-items: center;
  }
  .Modal_modal__content__t8Fmf {
    padding: 24px;
  }
}
@media (min-width: 1200px) {
  .Modal_modal__content__t8Fmf {
    max-width: 560px;
    padding: 16px;
  }
}

.Modal_act-order__body__MWA76 {
  height: auto;
  min-height: -webkit-fill-available;
  padding: 0;
}
.Modal_act-order__body__MWA76 .Modal_modal__content__t8Fmf {
  border-radius: 0;
  max-width: none;
}

.Modal_auth__zwZU1 .Modal_modal__wrapper__i6X9l {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Modal_auth__zwZU1 .Modal_modal__wp__9E-J9 {
  background: #F6F7F8;
}

@media (min-width: 1200px) {
  .Modal_order-info__LvZA3 .Modal_modal__wrapper__i6X9l {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media (min-width: 1200px) {
  .Modal_order-info__LvZA3 .Modal_modal__content__t8Fmf {
    max-width: 760px;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EAEA,aAAA;EACA,iBAAA;EACA,6BAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGM;EACE,iBAAA;EACA,mBAAA;AADR;AAIM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFR;AAKM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,4BAAA;EACA,6BAAA;AAJR;AAOM;EACE,qBAAA;AALR;AAWE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AATJ;AAYE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EAGA,gBAAA;EACA,kBAAA;EACA,8BAAA;AAZJ;AAeE;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAdJ;AAgBI;EACE,UAAA;AAdN;AAkBE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AAhBJ;AAkBI;EACE,gBAAA;EACA,YAAA;AAhBN;AAoBE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAnBJ;AAqBI;EALF;IAMI,WAAA;EAlBJ;AACF;AAqBE;EACE;IACE,mBAAA;EAnBJ;EAsBE;IACE,aAAA;EApBJ;AACF;AAsBE;EACE;IACE,gBAAA;IACA,aAAA;EApBJ;AACF;;AAyBE;EACE,YAAA;EACA,kCAAA;EACA,UAAA;AAtBJ;AAwBI;EACE,gBAAA;EACA,eAAA;AAtBN;;AA6BI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA1BR;AA6BI;EACI,mBAAA;AA3BR;;AAoCM;EADF;IAEI,aAAA;IACA,uBAAA;IACA,mBAAA;EAhCN;AACF;AAoCM;EADF;IAEI,gBAAA;IACA,UAAA;EAjCN;AACF","sourcesContent":[".modal {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  // justify-content: center;\n  padding: 12px;\n  min-height: 100vh;\n  min-height: var(--app-height);\n\n  &_order {\n    padding-left: 0;\n    padding-right: 0;\n\n    .modal {\n      &__wp {\n        padding-top: 99px; \n        padding-bottom: 0px;\n      }\n\n      &__body {\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 0;\n        height: auto;\n      }\n\n      &__content {\n        padding-top: 0;\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 0;\n        // overflow: hidden;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n\n      &__wrapper {\n        align-items: flex-end;\n      }\n    }\n  }\n  \n\n  &__wrapper {\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    min-height: 100%;\n    width: 100%;\n  }\n\n  &__wp {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    min-height: 100vh;\n    min-height: var(--app-height);\n    // padding-top: 16px;\n    // padding-bottom: 16px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: rgba(0, 0, 0, 0.4);\n  }\n\n  &__body {\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    height: 100%;\n    padding: 12px;\n    width: 100%;\n  }\n\n  &__content {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    background: #fff;\n    padding: 16px;\n    border-radius: 16px;\n    max-width: 756px;\n    transition: 0.3s;\n    opacity: 0;\n\n    &_opened {\n      opacity: 1;\n    }\n  }\n\n  &__logo {\n    position: absolute;\n    top: 42px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n\n    svg, img {\n      max-width: 200px;\n      height: auto;\n    }\n  }\n\n  &__logoTxt {\n    position: absolute;\n    bottom: 24px;\n    left: 50%;\n    transform: translateX(-50%);\n    color: var(--gray-500);\n    display: flex;\n  }\n\n  div.modal__lang {\n    position: absolute;\n    top: 42px;\n    right: 12px;\n\n    @media (min-width: 640px) {\n      right: 30px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    &__body {\n      align-items: center;\n    }\n\n    &__content {\n      padding: 24px;\n    }\n  }\n  @media (min-width: 1200px) {\n    &__content {\n      max-width: 560px;\n      padding: 16px;\n    }\n  }\n}\n\n.act-order {\n  &__body {\n    height: auto;\n    min-height: -webkit-fill-available;\n    padding: 0;\n\n    .modal__content {\n      border-radius: 0;\n      max-width: none;\n    }\n  }\n}\n\n.auth {\n  .modal {\n    &__wrapper {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    &__wp {\n        background: #F6F7F8;\n    }\n  }\n}\n\n.order-info {\n  .modal {\n\n    &__wrapper {\n      @media (min-width: 1200px) {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    &__content {\n      @media (min-width: 1200px) {\n        max-width: 760px;\n        padding: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__yEgVW`,
	"modal_order": `Modal_modal_order__N0KTm`,
	"modal__wp": `Modal_modal__wp__9E-J9`,
	"modal__body": `Modal_modal__body__PtdMz`,
	"modal__content": `Modal_modal__content__t8Fmf`,
	"modal__wrapper": `Modal_modal__wrapper__i6X9l`,
	"modal__content_opened": `Modal_modal__content_opened__CQEhb`,
	"modal__logo": `Modal_modal__logo__eOnGs`,
	"modal__logoTxt": `Modal_modal__logoTxt__m3SkR`,
	"modal__lang": `Modal_modal__lang__ZZiAz`,
	"act-order__body": `Modal_act-order__body__MWA76`,
	"auth": `Modal_auth__zwZU1`,
	"order-info": `Modal_order-info__LvZA3`
};
export default ___CSS_LOADER_EXPORT___;
